<template>
  <div>
    <div v-if="!sending && sendResults.length === 0">
      <v-layout justify-space-between align-content-space-around class="pa-2">
        <v-flex>
          <v-chip color="grey" text-color="white" @click="selectExtraEmails()"> Όλα</v-chip>
          <v-chip color="grey" text-color="white" @click="deselectEmails()"> Απεπιλογή</v-chip>
          <v-chip
            v-for="email in selectedEmails"
            color="light-blue lighten-4"
            close
            @input="remove(email)"
          >
            <span>{{email}}</span>
          </v-chip>
        </v-flex>
      </v-layout>
      <hr>
      <v-list style="max-height: 500px; overflow: auto">
        <v-list-tile>
          <v-list-tile-content>
            <v-checkbox v-if="customer"
                        v-model="selectedEmails"
                        :label="customer.Email"
                        close
                        :value="customer.Email"></v-checkbox>
          </v-list-tile-content>
          <v-list-tile-action>
            Kύριο Email Πελάτη
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile v-for="email in emails" :key="email.EmailID">
          <v-list-tile-content>
            <v-checkbox v-if="email.EmailID !== -1" v-model="selectedEmails" :label="email.Email"
                        :value="email.Email "></v-checkbox>
            <div v-if="email.EmailID == -1"> Διαγράφθηκε</div>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn  v-if="email.EmailID !== -1" flat outline fab small color="red" @click="deleteEmail(email)">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
      <v-btn title="Αποστολή" color="primary" @click="sendEmails()">
        <v-icon> mdi-send</v-icon>
        Αποστολή
      </v-btn>
    </div>

    <v-layout>
      <v-flex>
        <v-progress-circular indeterminate v-if="sending"></v-progress-circular>
      </v-flex>
    </v-layout>
    <v-alert :value="true" v-for="r in sendResults" :type="r.success?'success':'error'">
      {{r.reason}}
    </v-alert>
  </div>


</template>

<script>
  import ApiData from "../assets/ApiData";

  export default {
    name: "Emails",
    data: () => ({
      selectedEmails: [],
      sendResults: [],
      sending: false,
      hey: ""
    }),
    props: {customer: Object, emails: Array, offer: Object,},
    watch: {
      emails: function (v) {
        this.selectedEmails = [];
        this.sending = false;
        this.sendResults = [];
      }
    },
    methods: {
      deleteEmail(email ) {

        this.selectedEmails.splice(this.selectedEmails.findIndex(e=> e === email.Email), 1);
        this.selectedEmails = [...this.selectedEmails];
        ApiData.deleteExtraEmail(email.EmailID)
          .then(resp => {
            email.EmailID = -1;
            this.$notify({
              group: 'messages',
              type: 'success',
              text: 'Διαγράφθηκε'
            });
          })
          .catch(err=>{
            this.$notify({
              group: 'messages',
              type: 'error',
              text: err
            });
          })
        ;

      },
      remove(item) {
        this.selectedEmails.splice(this.selectedEmails.indexOf(item), 1);
        this.selectedEmails = [...this.selectedEmails]
      },
      selectExtraEmails() {
        this.selectedEmails = this.emails.map(e => e.Email);
      },
      deselectEmails() {
        this.selectedEmails = [];
      },
      sendEmails() {
        this.sending = true;
        ApiData.sendEmails(this.offer.ID, this.customer.ID, this.selectedEmails).then(
          resp => {
            this.sendResults = resp.data.data;
            this.sending = false;
          }
        )
      }
    },
    created() {
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Emails.vue